import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { CARD_TITLE_CLASS } from "@plannel/components/dashboard/DashboardCard";
import { FS } from "@plannel/utils/font-util";

/*
 * 대시보드 카드 헤더 — 제목(좌) + 컨트롤 클러스터(우).
 *   children    : 우측에 붙일 컨트롤(토글/Select 등)
 *   onDrill     : 주면 **제목 영역이 링크**가 된다(대상 리포트로 이동, 제목 옆 열기 아이콘).
 *                 차트 카드는 안에 범례·툴팁·토글·기어가 있어 카드 전체 클릭을 못 쓴다 →
 *                 차트 **바깥**(헤더 제목)만 클릭 영역으로 잡는 용도
 *   drillTitle  : 링크 툴팁(대상 리포트 이름)
 *   onDrillHover: (bool) 제목 hover 상태 — 호출측이 카드에 CARD_HOVER_SX 를 입혀
 *                 KPI 카드(카드 전체 클릭)와 **같은 파란 보더 하이라이트**를 내도록 한다
 *   onOpenConfig: 주면 맨 우측에 차트 설정 기어 표시
 *   dense       : 제목만 있는 헤더(테이블 카드 등) — alignItems center, mb 축소
 */
const DashboardCardHeader = ({ title, children, onDrill, drillTitle, onDrillHover, onOpenConfig, dense = false }) => {
  const titleNode = (
    <Typography className={CARD_TITLE_CLASS} sx={{ fontSize: FS.TITLE, fontWeight: 600, color: "inherit", transition: "color 0.15s" }}>
      {title}
    </Typography>
  );
  return (
    <Box sx={{
      display: "flex", justifyContent: "space-between",
      alignItems: dense ? "center" : "flex-start",
      mb: dense ? 0.5 : 0.75, gap: 1,
    }}>
      {onDrill ? (
        <Tooltip title={drillTitle ?? ""} placement="top-start">
          {/* 클릭 영역은 제목 + 아이콘까지(카드 전체 아님) — 차트/범례 클릭과 충돌하지 않는다 */}
          <Box
            onClick={onDrill}
            onMouseEnter={() => onDrillHover?.(true)}
            onMouseLeave={() => onDrillHover?.(false)}
            sx={{
              display: "flex", alignItems: "center", gap: 0.4,
              cursor: "pointer", color: "text.primary",
              transition: "color 0.15s",
              "&:hover": { color: "primary.main" },
            }}>
            {titleNode}
            <OpenInNewIcon sx={{ fontSize: 13, color: "text.secondary" }} />
          </Box>
        </Tooltip>
      ) : (
        <Box sx={{ color: "text.primary" }}>{titleNode}</Box>
      )}
      {(children || onOpenConfig) && (
        <Box sx={{ display: "flex", gap: 0.6, alignItems: "center" }}>
          {children}
          {onOpenConfig && (
            <IconButton size="small" onClick={onOpenConfig} sx={{ p: 0.25, color: "text.secondary" }}>
              <SettingsIcon sx={{ fontSize: 15 }} />
            </IconButton>
          )}
        </Box>
      )}
    </Box>
  );
};

export default DashboardCardHeader;
